import { render, staticRenderFns } from "./OtherHistoryTable.vue?vue&type=template&id=66892392&scoped=true"
import script from "./OtherHistoryTable.vue?vue&type=script&lang=js"
export * from "./OtherHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./OtherHistoryTable.vue?vue&type=style&index=0&id=66892392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66892392",
  null
  
)

export default component.exports